import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useAppDispatch } from "store/hooks"
import { showSeeMessageModal } from "store/modalSlise"
import { setSelectedMessageTemplateID } from "store/tempDataSlise"
import { ApiTypes, UITypes } from "types"

const TitleButton = styled.span`
  color: #2db2c8;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const ScheduledMessageTitleCell = ({ cell }: Props) => {
  const dispatch = useAppDispatch()
  const title = cell.getValue()?.value ? String(cell.getValue().value) : ""
  const message = cell.row.original.rowSettings?.item as ApiTypes.Model.DeviceMessage | undefined
  const templateId = message?.message_template_id

  if (!title || !templateId) return null

  const handleSeeMessage = () => {
    dispatch(setSelectedMessageTemplateID(templateId))
    dispatch(showSeeMessageModal(true))
  }

  return <TitleButton onClick={handleSeeMessage}>{title}</TitleButton>
}
